import styled from 'styled-components'

export const NoteDiv = styled.div`
    white-space: pre-line;
`
